export default __webpack_public_path__ + "static/media/Group 10497.0849e2f1.png";